import PadsIconGrey from "./PadsIconGrey";
export default PadsIconGrey;
